var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCalendar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 0.583496C5.74755 0.583496 6.08333 0.919283 6.08333 1.3335V1.91683H9.91667V1.3335C9.91667 0.919283 10.2525 0.583496 10.6667 0.583496C11.0809 0.583496 11.4167 0.919283 11.4167 1.3335V1.91683H12.6667C13.8173 1.91683 14.75 2.84957 14.75 4.00016V13.3335C14.75 14.4841 13.8173 15.4168 12.6667 15.4168H3.33333C2.18274 15.4168 1.25 14.4841 1.25 13.3335V4.00016C1.25 2.84957 2.18274 1.91683 3.33333 1.91683H4.58333V1.3335C4.58333 0.919283 4.91912 0.583496 5.33333 0.583496ZM4.58333 3.41683H3.33333C3.01117 3.41683 2.75 3.678 2.75 4.00016V5.91683H13.25V4.00016C13.25 3.678 12.9888 3.41683 12.6667 3.41683H11.4167V4.00016C11.4167 4.41438 11.0809 4.75016 10.6667 4.75016C10.2525 4.75016 9.91667 4.41438 9.91667 4.00016V3.41683H6.08333V4.00016C6.08333 4.41438 5.74755 4.75016 5.33333 4.75016C4.91912 4.75016 4.58333 4.41438 4.58333 4.00016V3.41683ZM13.25 7.41683H2.75V13.3335C2.75 13.6557 3.01117 13.9168 3.33333 13.9168H12.6667C12.9888 13.9168 13.25 13.6557 13.25 13.3335V7.41683Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calendar.4ada36b1.svg";
export { ForwardRef as ReactComponent };